/**
 * Convert a fraction (0–1) to a truncated percentile with ordinal suffix.
 * Examples:
 *   0.01 → "1st"
 *   0.079 → "7th"    (0.079*100=7.9 → truncate → 7)
 *   0.856 → "85th"  (0.856*100=85.6 → truncate → 85)
 *   1.0   → "100th"
 *
 * @param {number} frac — a value from 0 up to and including 1
 * @returns {string} the truncated percentile with ordinal, e.g. "85th"
 */
export function displayPercentile(frac: number): string {
  if (typeof frac !== "number" || frac < 0 || frac > 1 || Number.isNaN(frac)) {
    throw new RangeError("Input must be a number between 0 and 1");
  }

  const n = Math.trunc(frac * 100); // e.g. 0.856 * 100 → 85.6 → 85
  const mod100 = n % 100;

  // 11–13 always use "th"
  if (mod100 >= 11 && mod100 <= 13) {
    return `${n}th`;
  }

  // otherwise 1→st, 2→nd, 3→rd, everything else→th
  switch (n % 10) {
    case 1:
      return `${n}st`;
    case 2:
      return `${n}nd`;
    case 3:
      return `${n}rd`;
    default:
      return `${n}th`;
  }
}
